import { ReactElement } from 'react'
import styled from 'styled-components'

import { theme } from '@/styles/theme'

import { SectionTitle } from '@/components/elements/SectionTitle'
import { TitleLayout } from '@/components/enlayout'
import { CompanyLinks } from '@/components/enlayouts/Company/CompanyLinks'
import { Head } from '@/components/enlayouts/Head'

const sectionTitle = {
  enTitleText:  'Top Message',
}

export const TopMessagePage = () => {
  return (
    <>
      <Head
        title="Top Message | TRIAL Holdings, Inc."
        description='"Enriching the world through Retail DX" A message from the Chairman.'
        ogp={{ type: 'article', url: 'en/company/topmessage/' }}
      />
      <TopMessageContainer>
        <TopMessageTitle style={{ marginBottom: '70px' }}>
          <SectionTitle
            color="normal"
            enTitleText={sectionTitle.enTitleText}
          />
        </TopMessageTitle>
        <div><img src="/images/Sign_Hiro_Nagata_EN.png" style={{ width: '100%' }} alt="Hiro Nagata" /></div>
        <TopMessageText style={{ marginTop: '70px' }}>
          {/* <h3>Make the world a better place through Retail Tech</h3> */}
          <p>
            In 1974, Asahiya, the predecessor of TRIAL, was founded. In 1984, we rebranded as TRIAL Company, Inc., and from that moment, guided by the vision “Transforming retail with IT,” we have continued to embrace challenges.
          </p>
          <p>
            At that time, we visited Walmart stores in the United States and witnessed how, harnessing IT, they were experiencing rapid growth through the “Super Center” format. We were deeply impressed by how the “informational revolution in the retail industry” enriched people’s lives, and this experience profoundly inspired us.
          </p>
          <p>
            We aspired to spark an “informational revolution in the retail industry” in Japan too—to enrich and enhance people’s lives and thereby create a society that delivers happiness through the familiar comforts of everyday living. That “ambition” has been our driving force.
          </p>
          <p>
            Today, the TRIAL Group is guided by the vision “Revolutionize ‘real commerce’ around the globe with technology and practical savvy.,” and we continue to pursue bold innovation.
          </p>
          <p>
            My mission is to elevate this “ambition” into a sustainable “system” powered by each employee’s efforts, paving the way for enduring growth. With an eye on the next 100 years, we are building a robust management foundation and evolving into a visionary company.
          </p>
          <p>
            The journey ahead will not be easy. Yet, because so many employees, partners, and—most importantly—customers share in our passion that defies conventional logic or norms, the TRIAL Group stands where it is today.
          </p>
          <p>
            Gathering with our colleagues and boldly challenging the future, that spirit is the very essence of our name, “TRIAL.”
          </p>
          <p>
            What lies at the end of our journey? A richer life for our customers. By passing on the fruits of transformation through “better quality at lower cost,” and leveraging technology, we will create unprecedented convenience and entirely new shopping experiences.
          </p>
          <p>
            All of us at the TRIAL Group are committed to serving our customers and further improving distribution in Japan, now and in the years to come.
          </p>
          <RightSign>
            <p>
            TRIAL Holdings, Inc.<br />
            Representative Director and President<br />
            </p>
            <h4>Hiro Nagata</h4>
          </RightSign>
        </TopMessageText>
        <CompanyLinks padding={{ pc: '180px 0 0' }} />
      </TopMessageContainer>
    </>
  )
}

TopMessagePage.getLayout = function getLayout(page: ReactElement) {
  const pageTitle = {
    title: 'Corporate Information',
    subTitle: '',
  }

  const breadCrumbs = [
    { name: 'Home', path: '/en/' },
    { name: 'Corporate Information', path: '/en/company/' },
    { name: 'Top Message', path: '' },
  ]

  return (
    <TitleLayout {...pageTitle} breadCrumbs={breadCrumbs} isRequiredBackground>
      {page}
    </TitleLayout>
  )
}

const TopMessageContainer = styled.div`
  width: 1040px;
  padding-bottom: 130px;
  padding-top: 83px;
  margin: 0 auto;

  @media screen and (max-width: 1047px) {
    width: 100%;
    padding: 40px 20px 35px;
  }
`
const TopMessageTitle = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 140px;
  row-gap: 69px;

  @media screen and (max-width: 1047px) {
    margin-bottom: 58px;
    row-gap: 36px;
  }
`
const TopMessageText = styled.div`
  width: 100%;
  font-size: 18px;
  color: ${theme.colors.textTitle};
  text-align: left;
  letter-spacing: 0.36px;
  line-height: 32px;
  margin-top: 140px;

  h3 {
    font-size: 28px;
    letter-spacing: 1.68px;
    font-weight: bold;
    color: ${theme.colors.trialBlue};
    margin-bottom: 44px;
  }

  p {
    margin-bottom: 2em;
  }

  @media screen and (max-width: 1047px) {
    font-size: 15px;
    letter-spacing: 0.6px;
    line-height: 25px;
    margin-top: 58px;
    margin-bottom: 0px;

    h3 {
      max-width: 225px;
      font-size: 20px;
      letter-spacing: 2px;
      line-height: 30px;
      margin-bottom: 30px;
    }
  }
`
const RightSign = styled.div`
  text-align: right;
  line-height: 30px;
  margin-top: 68px;

  h4 {
    margin-top: 24px;
    font-size: 25px;
  }

  @media screen and (max-width: 1047px) {
    letter-spacing: 0.3px;
    margin-top: 46px;

    h4 {
      margin-top: 20px;
      font-size: 24px;
      letter-spacing: 0.48px;
    }
  }
`
